((() => {
  const PREMIUM_ICONS_DIR = '/wp-content/themes/adweek-next/src/images/icons/';
  const hasWidgetArea = document.querySelectorAll('.widget-area').length > 0;
  const isHomeLayout = (
    !hasWidgetArea && (
      document.body.classList.contains('home') ||
      document.body.classList.contains('inside_the_brand') ||
      document.body.classList.contains('cmo-sustainability-page'))
  );
  const isArchive = (
    hasWidgetArea &&
    !document.body.classList.contains('category') &&
    !document.body.classList.contains('search') &&
    !document.body.classList.contains('archive') &&
    !document.body.classList.contains('page-template-adw-archive')
  );
  const isArticle = document.body.classList.contains('article_page');

  /**
   * Returns the user's subscription status.
   * @returns {'customer' | 'registered' | 'anonymous'}
   */
  function getUserStatus () {
    if (!window.Zephr || !window.Zephr?.accessDetails?.isAuthenticated) return 'anonymous';
    return window.Zephr.accessDetails.activeProducts.length > 0 ? 'customer' : 'registered';
  }

  /**
   * Builds the inputs object for a single .zephr_premium_lock element.
   * Keys match the Zephr Console Custom Inputs for the is-article-locked feature.
   * @param {HTMLElement} el
   * @returns {object}
   */
  function buildDecisionInputs ({ dataset = {} }) {
    const { authoveridestartdate, authoverideendtdate, category, postpublishdays, authoverride, posttype, postId } = dataset;
    const today = new Date().toJSON().slice(0, 10);
    // Use loose != null to catch both null and undefined; also guard against empty string
    // so articles with no override dates don't incorrectly get isToday = true.
    const isToday = (
      authoveridestartdate != null && authoveridestartdate !== '' &&
      authoverideendtdate != null && authoverideendtdate !== '' &&
      today >= authoveridestartdate && today <= authoverideendtdate
    );
    const inputs = {
      category: category || '',
      authoverride_meta: authoverride || '',
      post_type: posttype || '',
      post_id: postId || '',
      isToday,
    };
    // Only include age when present — omitting it lets Zephr apply its own default,
    // matching what the old /zephr/decision-engine endpoint received.
    if (postpublishdays !== undefined && postpublishdays !== '') {
      inputs.age = postpublishdays;
    }
    return inputs;
  }

  /**
   * Inserts the appropriate premium lock badge into a .zephr_premium_lock element.
   * No-ops if the badge is already present.
   * @param {HTMLSpanElement} spanElement
   * @param {'customer' | 'registered' | 'anonymous'} userStatus
   */
  function applyLockBadge (spanElement, userStatus) {
    if (spanElement.hasChildNodes()) return;
    
    if (isArchive || isHomeLayout || isArticle || spanElement.parentElement.classList.contains('privacy_guide_premium_lock')) {
      spanElement.insertAdjacentHTML(
        'afterbegin',
        `<span class="locked_class is-premium-sm-sq d-inline-block me-1" title="This premium content is reserved for ADWEEK subscribers" data-bs-toggle="tooltip" data-bs-placement="top">
          <img loading="lazy" style="width:1.2em;height:1.2em" alt="icon-image" class="aw-premium-icon-only"
            src="${PREMIUM_ICONS_DIR}/${userStatus === 'customer' ? 'premium-icon-only-unlocked.svg' : 'premium-icon-only.svg'}"/>
        </span>`
      );
      return;
    }

    spanElement.insertAdjacentHTML(
      'afterbegin',
      `<span class="locked_class premium-content-label premium-svg-badge d-inline-block me-1"
        title="" data-bs-toggle="tooltip" data-bs-placement="top"
        style="width: 1.2em; height: 1.2em; ${userStatus === 'customer' ? `background-image: url(${PREMIUM_ICONS_DIR}/premium-icon-only-unlocked.svg);` : ''}"
        data-original-title="This premium content is reserved for ADWEEK subscribers"></span>`
    );
  }

  /**
   * Entry point. Collects all unprocessed .zephr_premium_lock nodes within the given
   * container and sends a single batch POST /zephr/decide request — one HTTP call
   * regardless of how many lock nodes are in scope.
   *
   * Idempotent: nodes are marked with data-zephr-checked="1" before the fetch fires,
   * so repeat calls (e.g. from multiple containers loading in quick succession) skip
   * already-processed nodes.
   *
   * @param {HTMLElement|Document} container - Scope for the lock query. Defaults to document.
   */
  async function triggerIntegratePremiumLock (container = document.body) {
    if (Object.keys(window.Zephr || {}).length === 0) return;

    // Webinars are sponsored content — exclude from the is-article-locked decision.
    const locks = Array.from(
      container.querySelectorAll('.zephr_premium_lock:not([data-zephr-checked="1"]):not([data-posttype="webinar"])')
    );
    if (locks.length === 0) return;

    locks.forEach(el => { el.setAttribute('data-zephr-checked', '1'); });

    const userStatus = getUserStatus();
    const features = locks.map(lock => ({
      slug: 'is-article-locked',
      inputs: buildDecisionInputs(lock),
    }));

    const { results = [] } = await fetch('/zephr/decide', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ features }),
    })
      .then(r => r.json())
      .catch(err => { console.error(err); return { results: [] }; }) || { results: [] };

    results.forEach(({ outputValue = "" }, i) => {
      if (outputValue === 'locked') applyLockBadge(locks[i], userStatus);
    });
  }

  window.triggerIntegratePremiumLock = triggerIntegratePremiumLock;

  // Trigger premium lock integration immediately for SSR content.
  document.addEventListener('DOMContentLoaded', () => triggerIntegratePremiumLock(document.body), { once: true });
})());
